
import Layout from '../../components/admin/Layout';
import FormPrecios from '../../components/admin/formPrecios';
import FormVentas from '../../components/forms/formVentas';

const Presupuestos = () => {


    return (
        <Layout
            pagina={"Presupuestos"}
        >
            <div className='w-full p-5 min-h-full'>
                <h2 className='text-center text-gray-700 text-sm md:text-xl'>Presupuestos</h2>
                <FormVentas />
            </div>
        </Layout>
    )
}

export default Presupuestos